import { render } from "./QuantityBarrierCard.vue?vue&type=template&id=62f0ca18&scoped=true"
import script from "./QuantityBarrierCard.vue?vue&type=script&lang=js"
export * from "./QuantityBarrierCard.vue?vue&type=script&lang=js"

import "./QuantityBarrierCard.vue?vue&type=style&index=0&id=62f0ca18&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f0ca18"]])

export default __exports__